import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/base/base.component';
import { DataTransformConfigViewModel } from 'src/app/viewModels/dataTransformConfigViewModel';
import { IngestConfigViewModel } from 'src/app/views/import-data/import-data.component';


@Component({
    selector: 'app-other-data-connector',
    templateUrl: './other-data-connector.component.html',
    styleUrls: ['./other-data-connector.component.css'],
    standalone: false
})
export class OtherDataConnectorComponent extends BaseComponent implements OnInit {

  @Input() dataTransformConfigViewModel: DataTransformConfigViewModel;
  @Input() ingestConfigViewModel: IngestConfigViewModel;

}
